






















































import Vue from "vue"
import axios from "axios"
import { Component } from "vue-property-decorator"
import { GenericResponse } from "@/data/models/response"
import Datepicker from "vuejs-datepicker"

@Component({
    components: {Datepicker},
})
export default class AddPicture extends Vue {
    pictureForm: {
        title?: string,
        text?: string,
        date?: Date,
        images: FileList | null
    } = {
        images: null,
    }

    loading: boolean = false
    error: boolean = false

    async onSubmitPicture(e: Event) {
        e.preventDefault()
        if (this.loading) {
            return
        }
        this.loading = true

        if (this.pictureForm.images && this.pictureForm.images.length > 0) {
            let images = []
            for (let image of this.pictureForm.images) {
                let base64Image = await this.readFile(image)
                images.push(base64Image)
            }

            await this.upload({
                title: this.pictureForm.title,
                text: this.pictureForm.text,
                date: this.pictureForm.date ? this.pictureForm.date.toISOString() : undefined,
                images: images.map(base64 => {
                    return {base64Image: base64}
                })
            })

            await this.$router.push({name: "pictures"})
        }
    }

    readFile(file: File): Promise<string> {
        return new Promise(e => {
                let reader = new FileReader()
                reader.onload = () => e(reader.result!.toString().split(",", 2)[1])
                reader.readAsDataURL(file)
            }
        )
    }

    upload(body: {
        title?: string,
        text?: string,
        date?: string,
        images: {
            base64Image: string,
        }[]
    }): Promise<any> {
        return axios.post(`${process.env.VUE_APP_BASE_URL}/cms/image`, body, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("jwt")
            },
        })
    }

    filesChange(files: FileList) {
        this.pictureForm.images = files
    }
}
